// 8.3.11 Video Moments UI (merged as `vm`).
const vm = {
 "label": "موقف من أجلك",
 "play": "تشغيل",
 "pause": "إيقاف مؤقت",
 "replay": "إعادة",
 "showTranscript": "أظهر النص",
 "hideTranscript": "أخفِ النص",
 "showMeaning": "أظهر المعنى",
 "hideMeaning": "أخفِ المعنى",
 "whatWouldYouSay": "ماذا ستقول؟",
 "placeholder": "اكتب ردّك ب{lang}",
 "respond": "ردّ",
 "natural": "هذا طبيعي.",
 "better": "طريقة أكثر طبيعية قد تكون:",
 "savePhrase": "احفظ العبارة",
 "saved": "تم الحفظ",
 "usefulPhrases": "عبارات مفيدة",
 "continueFriend": "تابع في Fluent Friend",
 "openInterview": "تدرّب على مقابلة كاملة",
 "startMission": "ابدأ المهمة",
 "videoFailed": "تعذّر تحميل الفيديو — ما زال بإمكانك قراءة المشهد والرد.",
 "respondFailed": "تعذّر الإرسال — حاول مرة أخرى.",
 "retryVideo": "إعادة تحميل الفيديو",
 "recommendedLevel": "المستوى المقترح",
 "video": "مشهد فيديو",
 "titles": {"vm_cafe_es": "الطلب في مقهى", "vm_hotel_fr": "استقبال الفندق", "vm_meet_de": "التعرّف على شخص جديد", "vm_interview_ar": "بداية مقابلة عمل", "vm_directions_sr": "السؤال عن الطريق", "vm_disagree_sr": "خلاف بسيط"},
 "roles": {"waitress": "النادلة", "customer": "الزبون", "receptionist": "موظفة الاستقبال", "guest": "النزيل", "interviewer": "المُقابِل", "candidate": "المرشّح", "tourist": "السائح", "passer-by": "أحد المارّة"}
};
export default vm;
